<div *ngIf="taxBasedProductsCols && taxBasedProductsCols.length > 0 && taxBasedProductsList && taxBasedProductsList.length > 0">
    <p-table [columns]="taxBasedProductsCols" [value]="taxBasedProductsList">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <ng-container *ngFor="let column of columns">
                    <th>
                        {{column.header}}
                    </th>
                </ng-container>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product let-columns="columns">
            <tr>
                <ng-container *ngFor="let column of columns">
                    <td>
                        {{ column.field == 'itemNo' || column.field == 'hsnsac' || column.field == 'taxPerc' 
                            ? product[column.field] 
                            : savedCurrencyExchangeRate && savedCurrencyUnit && savedCurrencyUnit?.symbol ? (product[column.field] | multicurrency: savedCurrencyExchangeRate : savedCurrencyUnit?.symbol : fractionDigits) 
                            : (product[column.field] | customNumberFormat:fractionDigits | currencySymbol) }}
                    </td>
                </ng-container>
            </tr>
        </ng-template>
    </p-table>
</div>